const CallingApiTabContent: React.FC = () => {
	return <div className="max-w-2xl">Calling API...</div>;
};

export default CallingApiTabContent;
